import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import { uploadImageToS3 } from '../services/utils/uploadImageToS3'

const ItemOptionModal = ({ show, onClose, onAdd, experienceSlug, item }) => {
	const [name, setName] = useState('')
	const [type, setType] = useState('inclusion')
	const [allowAddToCheckIn, setAllowAddToCheckIn] = useState(true)
	const [file, setFile] = useState(null)
	const [preview, setPreview] = useState('')
	const [uploading, setUploading] = useState(false)

	useEffect(() => {
		if (item) {
			setName(item.name || '')
			setType(item.type || 'inclusion')
			setAllowAddToCheckIn(item.allowAddToCheckIn !== false)
			setPreview(item.imageUrl || '')
			setFile(null) // New upload is optional
		} else {
			setName('')
			setType('inclusion')
			setAllowAddToCheckIn(true)
			setPreview('')
			setFile(null)
		}
	}, [item])

	const handleFileChange = (e) => {
		const selected = e.target.files[0]
		if (selected) {
			setFile(selected)
			setPreview(URL.createObjectURL(selected))
		}
	}

	const handleSubmit = async () => {
		if (!name || !type) return alert('Name and type are required.')

		setUploading(true)
		try {
			let imageUrl = item?.imageUrl || ''
			if (file) {
				imageUrl = await uploadImageToS3(file)
			}

			await onAdd({ name, type, allowAddToCheckIn, imageUrl })
		} catch (err) {
			alert(err.message || 'Upload failed')
		} finally {
			setUploading(false)
		}
	}

	return (
		<Modal show={show} onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>{item ? 'Edit' : 'Add'} Item Option</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form.Group className='mb-3'>
					<Form.Label>Name</Form.Label>
					<Form.Control
						type='text'
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
				</Form.Group>

				<Form.Group className='mb-3'>
					<Form.Label>Type</Form.Label>
					<Form.Select value={type} onChange={(e) => setType(e.target.value)}>
						<option value='inclusion'>Inclusion</option>
						<option value='addition'>Addition</option>
					</Form.Select>
				</Form.Group>

				<Form.Group className='mb-3'>
					<Form.Check
						type='checkbox'
						label='Allow this item to be added to check-ins'
						checked={allowAddToCheckIn}
						onChange={(e) => setAllowAddToCheckIn(e.target.checked)}
					/>
				</Form.Group>

				<Form.Group className='mb-3'>
					<Form.Label>Image</Form.Label>
					<Form.Control
						type='file'
						accept='image/*'
						onChange={handleFileChange}
					/>
					{preview ? (
						<img
							src={preview}
							alt='Preview'
							style={{ width: '100%', marginTop: '10px', borderRadius: '8px' }}
						/>
					) : null}
				</Form.Group>
			</Modal.Body>
			<Modal.Footer>
				<Button variant='secondary' onClick={onClose}>
					Cancel
				</Button>
				<Button onClick={handleSubmit} disabled={uploading}>
					{uploading ? 'Uploading...' : item ? 'Save Changes' : 'Add'}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default ItemOptionModal
